import React, { useRef, useState, useEffect } from "react";
import { Button } from "reactstrap";
import html2canvas from "html2canvas";
// import burger from "../../../../assets/qrcode/natapola-removebg.png";
// import sebs from "../../../../assets/sebs/sebs.png";
import burger from "../../../assets/images/Dibya.png";
import sebs from "../../../assets/imageLogo.jpeg";
import { QRCodeCanvas } from "qrcode.react";
import "./QrModalV2.css";
// import BreadCrumb from "../../../../Components/Common/BreadCrumb";
// import OrganizationService from "../../../../Services/QRCodeServices/OrganizationManagement/OrganizationService";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import OrganizationService from "../../../services/OrderingServices/OrganizationService";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { getLoggedInUser } from "../../../helpers/fakebackend_helper";
import restro from "../../../assets/orderingSystem/logo.png";
import scanWaveSvg from "../../../assets/QRMenu/hello 11.svg";

const QrModalV2 = () => {
  const { id } = useParams();
  console.log("🚀 ~ id:", id);
  const navigate = useNavigate();
  const modalRef = useRef(null);
  const proxyUrl = `https://api.qrmenu.asia/api/proxy`;

  const user = JSON.parse(localStorage.getItem("user"));
  const [data, setData] = useState([]);
  const authUser = getLoggedInUser();
  const orgData = authUser?.organizationInfo;
  const orgCode = authUser?.organizationInfo?.orgCode;
  const url = `${window.location.origin}/${orgCode}?source=qr-menu`;
  console.log("🚀 ~ orgCode:", data.orgCode);

  const fetchDetail = async () => {
    try {
      const response = await OrganizationService.detail(id);
      console.log("🚀 ~ fetchDetail ~ response:", response);
      console.log("🚀 ~ fetchDetail ~ response:", response);
      setData(response);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchDetail();
  }, []);

  const downloadAsImage = async () => {
    try {
      const modalElement = modalRef.current;

      const canvas = await html2canvas(modalElement, {
        scale: 2,
        // useCORS: true,
        backgroundColor: "#f0f7ff",
        logging: false,
        proxy: proxyUrl,
        imageSettings: {
          crossOrigin: "Anonymous",
        },
      });

      canvas.toBlob(
        (blob) => {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = `${data?.name || "qr-code"}-menu.jpg`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        },
        "image/jpeg",
        1.0
      );
    } catch (error) {
      console.error("Error generating image:", error);
    }
  };

  const handlePrint = async () => {
    try {
      const modalElement = modalRef.current;

      const canvas = await html2canvas(modalElement, {
        scale: 3,
        // useCORS: true,
        backgroundColor: "#f0f7ff",
        logging: false,
        proxy: proxyUrl,
        imageSettings: {
          crossOrigin: "Anonymous",
          // src: OrgLogo,
        },
      });

      const printWindow = window.open("", "_blank");
      if (!printWindow) {
        alert("Please allow popups to print");
        return;
      }

      printWindow.document.write(`
                <html>
                  <head>
                    <title>Print QR Code</title>
                    <style>
                      @media print {
                        body {
                          margin: 0;
                          padding: 0;
                        }
                        img {
                          width: 100%;
                          height: auto;
                        }
                      }
                    </style>
                  </head>
                  <body>
                    <img src="${canvas.toDataURL("image/jpeg", 1.0)}" />
                    <script>
                      window.onload = function() {
                        window.print();
                        window.onafterprint = function() {
                          window.close();
                        }
                      }
                    </script>
                  </body>
                </html>
            `);
      printWindow.document.close();
    } catch (error) {
      console.error("Error printing:", error);
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="QR Menu" pageTitle="Dashboard" />
      </div>
      <div className="qr-modal-container d-flex flex-column justify-content-center align-items-center">
        <style>
          {`
                        .action-buttons {
                            width: 27rem;
                            /* width: 20rem; */
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            gap: 10px;
                            /* background-color: #2e76c7; */
                        }

                        .action-btn {
                            background-color: #f74a4a;
                            border: none;
                            padding: 8px 20px;
                            border-radius: 5px;
                            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
                            transition: all 0.3s ease;
                            width: 10rem;
                        }

                        .action-btn:hover {
                            background-color: #f63535;
                            box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
                            transform: translateY(-2px);
                        }

                        .action-btn:active {
                            transform: translateY(0);
                            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
                        }
                        
                        @media (max-width: 768px){
                        .qr-modal-container{
                            width: 27rem;
                        }
                    `}
        </style>
        {/* <div className="d-print-none d-flex justify-content-end align-items-center w-100">
          <Button
            className="back-btn mb-2"
            color="danger"
            onClick={() => navigate(`/organization/detail/${id}`)}
          >
            {" "}
            Back
          </Button>
        </div> */}

        <div className="model-container-large shadow-lg" ref={modalRef}>
          <div className="scan-container">
            <div className="scan-text">SCAN</div>
            <div className="more-menu-text">To view our menu</div>
            <div className="image-with-border"></div>
            {/* <div>
              <img src={scanWaveSvg} className="scan-wave" alt="decor" />
            </div> */}
          </div>

          <div className="qr-code">
            <QRCodeCanvas
              value={url}
              size={180}
              bgColor="#f0f7ff"
              fgColor="#000000"
              level="H"
            />
          </div>

          <div className="bottom-container">
            <div className="powered-app">POWERED BY:</div>
            <div>
              <img
                src={restro}
                className="restro-logo"
                crossOrigin="anonymous"
              />
            </div>
            <div className="contact-container">
              <p>
                <i className="ri-chrome-line"></i>
                <span>www.danfesolution.com</span>
              </p>

              <p>
                <i className="ri-mail-line"></i>
                <span>info@danfesolution.com</span>
              </p>

              <p>
                <i className="ri-phone-line"></i>
                <span>+977 9802368068</span>
              </p>
            </div>
          </div>
        </div>

        <div
          className="action-buttons d-print-none d-flex justify-content-center align-items-center gap-2 mt-3"
          style={{ width: "27rem" }}
        >
          <Button className="action-btn" onClick={downloadAsImage}>
            Download QR
          </Button>
          <Button className="action-btn" onClick={handlePrint}>
            Print QR
          </Button>
        </div>
      </div>
    </div>
  );
};

export default QrModalV2;
